import { motion, useMotionValue, useSpring } from "framer-motion";
import { QRCodeSVG } from "qrcode.react";
import { Sparkle } from "lucide-react";
import { MC_MARK_URL, PAYOFF, PORTRAIT_URL, QUOTE, ROLE } from "@/lib/contact";

const EASE = [0.22, 1, 0.36, 1];

export const BusinessCard = ({ flipped }) => {
    const tiltX = useMotionValue(0);
    const tiltY = useMotionValue(0);
    const rotateX = useSpring(tiltX, { stiffness: 140, damping: 18 });
    const rotateY = useSpring(tiltY, { stiffness: 140, damping: 18 });

    const handleMove = (e) => {
        const r = e.currentTarget.getBoundingClientRect();
        tiltY.set(((e.clientX - r.left) / r.width - 0.5) * 9);
        tiltX.set(-((e.clientY - r.top) / r.height - 0.5) * 9);
    };

    const handleLeave = () => {
        tiltX.set(0);
        tiltY.set(0);
    };

    return (
        <div className="card-scene" data-testid="business-card">
            <motion.div
                style={{ rotateX, rotateY }}
                onMouseMove={handleMove}
                onMouseLeave={handleLeave}
                className="card-preserve"
            >
                <motion.div
                    className="card-preserve relative aspect-[1/1.58] w-full"
                    animate={{ rotateY: flipped ? 180 : 0 }}
                    transition={{ duration: 0.9, ease: EASE }}
                >
                    <div
                        data-testid="business-card-front"
                        className="card-frame card-face overflow-hidden rounded-2xl bg-[#121418]"
                    >
                        <img
                            src={PORTRAIT_URL}
                            alt="Mino Cesari"
                            className="absolute inset-0 h-full w-full object-cover object-top"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#090a0c] via-[#090a0c]/35 to-[#090a0c]/55" />
                        <div className="absolute inset-3 rounded-xl border border-[rgba(226,192,117,0.28)]" />
                        <div className="absolute inset-x-0 top-0 flex items-center justify-between px-6 pt-5">
                            <img
                                src={MC_MARK_URL}
                                alt="MC — Mino Cesari"
                                className="h-16 w-auto drop-shadow-[0_4px_16px_rgba(0,0,0,0.6)]"
                                data-testid="card-front-logo"
                            />
                            <Sparkle className="h-4 w-4 text-[#e2c075]" />
                        </div>
                        <div className="absolute inset-x-0 bottom-0 px-7 pb-7">
                            <p className="font-code text-[10px] uppercase tracking-[0.35em] text-[#a1a8b3]">
                                {PAYOFF}
                            </p>
                            <h2 className="font-display mt-2 text-4xl font-semibold leading-none text-[#f4f1ea]">
                                Mino <span className="italic text-gold-gradient">Cesari</span>
                            </h2>
                            <div className="gold-hairline my-4" />
                            <p className="font-code text-[10px] uppercase leading-relaxed tracking-[0.22em] text-[#e2c075]/90">
                                {ROLE}
                            </p>
                        </div>
                    </div>
                    <div
                        data-testid="business-card-back"
                        className="card-frame card-face card-face-back overflow-hidden rounded-2xl bg-[#121418]"
                    >
                        <div className="absolute inset-3 rounded-xl border border-[rgba(226,192,117,0.28)]" />
                        <div className="flex h-full flex-col items-center justify-between px-8 py-9">
                            <div className="flex flex-col items-center gap-2">
                                <img
                                    src={MC_MARK_URL}
                                    alt="MC — Mino Cesari"
                                    className="h-16 w-auto"
                                    data-testid="card-back-logo"
                                />
                                <p className="font-code text-[9px] uppercase tracking-[0.35em] text-[#a1a8b3]">
                                    {PAYOFF}
                                </p>
                            </div>
                            <div className="flex flex-col items-center gap-5">
                                <div className="rounded-2xl bg-[#f4f1ea] p-4 shadow-[0_10px_40px_rgba(0,0,0,0.5)]">
                                    <QRCodeSVG
                                        value={window.location.origin}
                                        size={168}
                                        level="H"
                                        fgColor="#090a0c"
                                        bgColor="#f4f1ea"
                                    />
                                </div>
                                <p className="font-code text-[10px] uppercase tracking-[0.3em] text-[#e2c075]">
                                    Inquadra · Apri il biglietto
                                </p>
                            </div>
                            <p className="font-display text-center text-sm italic leading-snug text-[#a1a8b3]">
                                “{QUOTE}”
                            </p>
                        </div>
                    </div>
                </motion.div>
            </motion.div>
        </div>
    );
};
